"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useSticky = function useSticky(element) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0],
    setIsSticky = _useState2[1];
  (0, _react.useEffect)(function () {
    var scrollHandler = function scrollHandler() {
      var bounding = element.current.getBoundingClientRect();
      var isStickyNow = bounding.top < 0 && bounding.bottom > 0;
      setIsSticky(isStickyNow);
    };
    window.addEventListener('scroll', scrollHandler);
    return function () {
      return window.removeEventListener('scroll', scrollHandler);
    };
  }, []);
  return {
    isSticky: isSticky
  };
};
var StickyHeader = function StickyHeader(props) {
  var header = props.header,
    table = props.table;
  var ref = (0, _react.useRef)();
  var headerRef = (0, _react.useRef)();
  var wrapperRef = (0, _react.useRef)();
  var _useSticky = useSticky(ref),
    isSticky = _useSticky.isSticky;
  (0, _react.useEffect)(function () {
    var scrollWrapper = ref.current.closest('[data-table-scroll-wrapper]');
    if (!scrollWrapper) {
      return;
    }
    wrapperRef.current = scrollWrapper;
    var handleWrapperScroll = function handleWrapperScroll() {
      if (!wrapperRef.current || !headerRef.current) {
        return;
      }
      headerRef.current.scrollLeft = wrapperRef.current.scrollLeft;
    };
    wrapperRef.current.addEventListener('scroll', handleWrapperScroll);
    return function () {
      return wrapperRef.current.removeEventListener('scroll', handleWrapperScroll);
    };
  }, []);

  // duplicate dimensions for the header
  (0, _react.useEffect)(function () {
    if (!isSticky || !ref.current || !headerRef.current) {
      return;
    }
    var columns = ref.current.querySelectorAll('thead tr:first-child th');
    var widths = [];
    var _iterator = _createForOfIteratorHelper(columns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var column = _step.value;
        widths.push(column.getBoundingClientRect().width);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var theadColumns = headerRef.current.querySelectorAll('thead tr:first-child th');
    var _iterator2 = _createForOfIteratorHelper(theadColumns),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _column = _step2.value;
        if (widths.length === 0) {
          break;
        }
        _column.style.minWidth = "".concat(widths.shift(), "px");
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (wrapperRef.current) {
      var bounding = wrapperRef.current.getBoundingClientRect();
      headerRef.current.style.left = "".concat(bounding.left, "px");
      headerRef.current.style.width = "".concat(bounding.width, "px");
    }
  });
  (0, _react.useEffect)(function () {
    if (isSticky && wrapperRef.current && headerRef.current) {
      headerRef.current.scrollLeft = wrapperRef.current.scrollLeft;
    }
  }, [isSticky]);
  var handleHeaderScroll = function handleHeaderScroll() {
    if (!wrapperRef.current || !headerRef.current) {
      return;
    }
    wrapperRef.current.scrollLeft = headerRef.current.scrollLeft;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSticky && /*#__PURE__*/_react["default"].createElement("div", {
    ref: headerRef,
    className: _style["default"].sticky,
    onScroll: handleHeaderScroll
  }, header), /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, table));
};
StickyHeader.propTypes = {
  header: _propTypes["default"].node,
  table: _propTypes["default"].node
};
var _default = exports["default"] = StickyHeader;